var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sf-header__logo"},[_c('span',{on:{"click":function($event){return _vm.handleToHome()}}},[_c('SvgImage',{attrs:{"icon":"unineedLogo","label":"unineed-logo","width":"164","height":"20"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }